import { render, staticRenderFns } from "./toggle-switch.vue?vue&type=template&id=0c8e8df8&scoped=true"
import script from "./toggle-switch.vue?vue&type=script&lang=js"
export * from "./toggle-switch.vue?vue&type=script&lang=js"
import style0 from "./toggle-switch.vue?vue&type=style&index=0&id=0c8e8df8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8e8df8",
  null
  
)

export default component.exports